import { createFileRoute } from "@tanstack/react-router";
import { QrCodeLoginPage } from "@/features/pointage-qr/components/QrCodeLoginPage";

export const Route = createFileRoute("/_auth/pointage/qr-code")({
  component: QrCodeLoginPage,
});